import { render, staticRenderFns } from "./MessageMore.vue?vue&type=template&id=57d3def2&"
import script from "./MessageMore.vue?vue&type=script&lang=js&"
export * from "./MessageMore.vue?vue&type=script&lang=js&"
import style0 from "./MessageMore.vue?vue&type=style&index=0&id=57d3def2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports